import { Component, OnInit, inject } from '@angular/core';
import { waitForAsync } from '@angular/core/testing';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import DataSource from 'devextreme/data/data_source';
import { Observable } from 'rxjs';
import { SearchServiceModel } from 'src/app/store/self-diagnostic/search-service/model';
import { SearchServiceFacade } from '../../../../store/self-diagnostic/search-service/facade';
import { AbstractSelfDiagnosticApiService } from '../../../../core/services/abstract/abstract-self-diagnostic-api-service';
import { ServiceCatalogFacade } from 'src/app/store/self-diagnostic/service-catalog/facade';
import { ServiceModel } from 'src/app/store/self-diagnostic/service-catalog/model';
import { ServiceMenuItem } from 'src/app/core/models/service-menu-item';

@Component({
  selector: 'app-self-diagnostic-search-service',
  templateUrl: './search-service.component.html',
  styleUrls: ['./search-service.component.scss'],
  host: {
    class: 'd-flex justify-content-center',
  },
  standalone: false,
})
export class SearchServiceComponent implements OnInit {
  private router = inject(Router);
  translate = inject(TranslateService);
  private facade = inject(SearchServiceFacade);
  private selfDiagnosticApiService = inject(AbstractSelfDiagnosticApiService);
  private serviceCatalogFacade = inject(ServiceCatalogFacade);

  public services$: Observable<SearchServiceModel[]>;
  public services: SearchServiceModel[] = [];

  public serviceId: number;
  public service: SearchServiceModel;

  public selectMenuItem: ServiceMenuItem;
  public allServices: ServiceModel[] = [];
  public searchDataSource: DataSource;
  private knowledgeLibraryMessage: string;

  public async ngOnInit() {
    this.translate.get('KNOWLEDGE_LIBRARY').subscribe(value => {
      this.knowledgeLibraryMessage = value;
    });

    this.serviceCatalogFacade.entities$.subscribe(z => {
      this.allServices = z;
    });

    this.searchDataSource = new DataSource({
      key: 'ID',
      load: async loadOptions => {
        return await this.selfDiagnosticApiService
          .searchService(loadOptions.searchValue)
          .toPromise()
          .then(response => {
            let result: ServiceMenuItem[] = [];
            if (response.result) {
              response.result.forEach(x => {
                //result.push(new ServiceMenuItem(x.id, x.nameRu, null, this.knowledgeLibraryMessage));
              });
            }

            if (this.allServices) {
              this.allServices.forEach(service => {
                if (service.nameRu.toLowerCase().includes(loadOptions.searchValue.toLowerCase())) {
                  //result.push(new ServiceMenuItem(service.code, service.nameRu, service.category.code, service.category.nameRu));
                }
              });
            }

            return { data: result };
          });
      },
    });
  }

  public selectService($event) {
    if ($event.selectedItem.searchServiceModel) {
      this.service = <SearchServiceModel>$event.selectedItem.searchServiceModel;

      this.facade.setSelected(this.service);
      this.selectMenuItem = null;
    } else {
      this.service = null;
      this.facade.setSelected(null);
      this.selectMenuItem = $event.selectedItem;
    }
  }

  public goToSelfDiagnosticSteps(serviceId: number) {
    this.router.navigate(['/self-diagnostic/self-diagnostic-step', serviceId]);
  }

  public goToCatalog() {
    this.router.navigate(['/self-diagnostic']);
  }

  public createOrder() {
    //this.router.navigate(['/orders/order'], {
    //  queryParams: {
    //    categoryId: this.selectMenuItem.categoryId,
    //    serviceId: this.selectMenuItem.id,
    //    serviceName: this.selectMenuItem.name,
    //    serviceTypeId: null
    //  }
    //});
  }
}
